import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * `/ko` locale subtree (Korean). Locale activation is handled globally by
 * `LocaleSync` (readLocale() is URL-prefix-aware), so this layout only renders
 * its children. English stays at the unprefixed root.
 */
export const Route = createFileRoute("/ko")({
	component: KoLayout,
});

function KoLayout() {
	return <Outlet />;
}
